import { base_schema } from "./schema_base.js";

class SchemaBuilder {
  constructor() {
    this.schema = base_schema;
    this.actions = {
      /*name: definition*/
    }
  }

  build() {
    this.schema.definitions.Actions.items.anyOf[0].properties.action.enum = Object.keys(this.actions).sort();
    this.schema.definitions.Actions.items.anyOf[0].allOf = Object.values(this.actions).sort();

    return this.schema;
  }

  registerAction(name, definition) {
    this.actions[name] = definition;
  }
}

let Schema = new SchemaBuilder();
export default Schema;
